import React from 'react';
import { Button, Space } from 'antd-mobile';
import { GlobalOutline } from 'antd-mobile-icons';
import { useI18n } from '../hooks/useI18n';

interface LanguageSwitcherProps {
  style?: React.CSSProperties;
  showIcon?: boolean;
  size?: 'mini' | 'small' | 'middle' | 'large';
}

export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ 
  style, 
  showIcon = true, 
  size = 'middle' 
}) => {
  const { t, changeLanguage, isLanguage } = useI18n();

  const handleLanguageChange = (lng: string) => {
    changeLanguage(lng);
  };

  return (
    <div style={style}>
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        marginBottom: '12px',
        color: '#6b7280',
        fontWeight: '500'
      }}>
        {showIcon && <GlobalOutline style={{ marginRight: '8px' }} />}
        {t('common.language')}
      </div>
      <Space>
        <Button
          size={size}
          color={isLanguage('zh') ? 'primary' : 'default'}
          fill={isLanguage('zh') ? 'solid' : 'outline'}
          onClick={() => handleLanguageChange('zh')}
        >
          {t('common.chinese')}
        </Button>
        <Button
          size={size}
          color={isLanguage('en') ? 'primary' : 'default'}
          fill={isLanguage('en') ? 'solid' : 'outline'}
          onClick={() => handleLanguageChange('en')}
        >
          {t('common.english')}
        </Button>
      </Space>
    </div>
  );
};

export default LanguageSwitcher;